<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      创之道是一家集开发，运营，维护与一体的科技创新公司
    </p>
    <h3>业务包括：网站建设，app定制开发，小程序，公众号开发</h3>
    <h3>公司样貌</h3>
    <el-row>
      <el-col :span="6">
        <img src="../assets/img/1.jpg">
      </el-col>
      <el-col :span="6">
        <img src="../assets/img/2.jpg">
      </el-col>
      <el-col :span="6">
        <img src="../assets/img/3.jpg">
      </el-col>
      <el-col :span="6">
        <img src="../assets/img/4.jpg">
      </el-col>
    </el-row>
    <h3>往期作品</h3>
    <ul>
      <li><h4>每日乐购</h4></li>
      <li><h4>每日免单</h4></li>
      <li><h4>积分联盟</h4></li>
    </ul>
    <el-row>
      <h4>公司地址：河南省郑州市二七区航海中路二七升龙中心B座1709-1710</h4>
      <h4>联系电话：0371-61315130</h4>
    </el-row>
    <el-row>
      <a href="http://beian.miit.gov.cn" target="_blank">豫ICP备19005804号</a>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img{
  width: 300px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
